<template>
  <div class="banner-modal">
    <sweet-modal ref="bannerModal" v-on:close="onClose" class="bannerModal" :title="type+' Banner'" width="80%" >
    <div>

          <div class="form__group" style="display:flex;margin:0">
            <h1 style="font-size:15px;display:flex; width: 15%; align-items: center;">Add Banner</h1>
            <input
              type="file"
              label="Photo"
              name="photo"
              v-validate="'required'"
              data-vv-value-path="input"
              data-vv-name="photo"
              :has-error=" errors.has('photo')"
              @change="changeFileHandle"
              :required="true"
              class="form-control"
              :class="{'is-danger': hasError }"
              style="width: 65%;"
              id="uploadInputFile"
            >
            
            <div class="form__group" style="display:flex; align-items: center;">
              <button
                class="btn btn--primary"
                id="submit-form"
                :disabled="choosed"
                @click="onupload()"
              >Upload</button>
            </div>
          
            <h1 style="font-size:26px; color:green;" v-if="suceessmessage">&#10004</h1>
          </div>
          <span class="help is-danger" style="color: red;margin-left:15%" v-if="hasError">{{ errorMessage }}</span>
          <h3 v-if="aspectRatioError" style="color: red;margin-left:15%">{{aspectRatioError}}</h3>
          <progress max="100" :value.prop="uploadPercentage" v-if="uploadingBar" style="width:50%;margin-top:20px;"></progress>
          <div style="display:flex; padding-top:1rem">
              <div id="preview" class="landscape" v-if="url">
                <h1>Preview Banner</h1>
                <img  :src="url" id="image" alt="Preview Banner Image">
              </div>
              <div id="preview" class="landscape" v-if="bannerDetail.ImageUrl">
                <div style="display:flex">
                <h1>Saved Banner</h1>
                <v-popover offset="16" placement = 'top-center' style="float: right;padding-left: 17rem;">
                    <span style="color: red;">Remove Banner</span>
                    <a class="tooltip-target b3"  style="color: black;font-size: large;cursor: pointer;">&#10062;</a>

                  <template slot="popover">
                    <p>
                      {{ msg }}
                    </p>
                    <br/>
                    <div style="display:flex; padding-left: 5rem;">
                    <button class="btn btn--danger" @click="selectNoBanner('NORMAL')" >yes</button>
                    &nbsp;&nbsp;&nbsp;
                    <button class="btn btn--gray" v-close-popover>no</button>
                    </div>
                  </template>
                </v-popover>
                </div>
                <img  :src="bannerDetail.ImageUrl" alt="Banner Image">
              </div>  
          </div>

          <div v-if="bannerLink" style="margin-top:5px">
            <h1>Saved Banner Link</h1>
            <a :href="bannerLink" target="blank">{{bannerLink}}</a>
            <br/><br/>
          </div>
        
          <div class="form__group" style="display:flex;">
            <h1 style="font-size:15px;display:flex; width: 15%; align-items: center;">{{type}} Banner Link: </h1>
            
            <input type="text" v-model="bannerDetail.Link"  name="Link" class="form-control" style="width:50%">
            &nbsp;&nbsp;
            <p style="color: red;margin-top: 10px;">{{linkError}}</p>
          </div>
          <div>
            <label for="type" style="font-size:15px">Banner Type:</label>   
            <select v-model="bannerDetail.Type" label="Banner Type" name="type" style="height: 33px;margin-left:50px">         
              <option value="REGULAR">REGULAR</option>
              <option value= "US BANNER">US BANNER</option>
            </select>
          </div>
          <div style="text-align:center">
            <button class="btn btn--primary" id="save-banner" style="float:none"  @click="saveBanner()">SAVE</button>
          </div>

    </div>
    </sweet-modal>
  </div>
</template>

<script>
import Vue from "vue"
import {
    mapGetters,
    mapActions
  } from 'vuex'
import { SweetModal } from "sweet-modal-vue"
import Selectize from '@/components/Selectize'
import TextField from '@/components/Forms/TextField'
import S3UploadService from "@/services/s3Upload"
import axios from 'axios'


export default {
  name: "add-edit-banner",
  data: () => ({
    bannerDetail:{
      "ImageUrl": "",
      "Link": "",
      "Type": "REGULAR",
      "AddedBy": '',
      "LastModBy": '',
      "AddedOn": '',
      "LastModOn": ''
    },
    bannerLink :'',
    suceessmessage:null,
    errorMessage: "Fill in the photo with size below 1 mb",
    aspectRatioError: null,
    uploadingBar: false,
    msg:'Are you sure want to remove banner?',
    hasError: false,
    choosed: true,
    file: {},
    url:null,
    uploadPercentage: 0,
    interval: null,
    suceessLinkMessage:false,
    linkError:null,
  }),
  props: {
    show: false,
    bannerData: {},
    type:'',
  },
  computed: {
      ...mapGetters({
        trainer: 'Trainer/trainer'
      })
  },
  methods: {
    changeHandle(){
      this.invalidError=false
      this.invalidMsg=""
    },
    onClose() {      
      this.reset()
      this.$emit("closed", true)
    },
    openBannerModal() {     
      if(this.type == 'Edit'){
        Object.assign(this.bannerDetail, this.bannerData)
        this.bannerLink = this.bannerDetail.Link
      }
      this.$refs.bannerModal.open()      
    },
    changeFileHandle(e) {    
      this.suceessmessage = null      
      const originalFile = e.target.files[0]
      this.url = URL.createObjectURL(originalFile)
      const file = new FormData()
      file.append("file", originalFile)
      const size = originalFile.size / 1024
      if (size > 1024) {
        this.hasError = true
        this.aspectRatioError = null
        this.choosed = true
      } else {
        this.hasError = false
        this.aspectRatioError = null
        this.choosed = false
        this.file.name = originalFile.name
        this.file.data = originalFile
      }
    },
    onupload(){
      var that =this
      let aspectRatio =
        document.getElementById("image").clientWidth /
        document.getElementById("image").clientHeight
        aspectRatio = Math.round(aspectRatio)
      if (aspectRatio == 3) {
        this.aspectRatioError = null
        this.hasError = false
        this.uploadingBar = true
        this.startBar()
        S3UploadService.uploadAndGetBannerLink(this.file,"NORMAL", (data, err) => {
          //console.log("data--",data)
          that.bannerDetail.ImageUrl = data
          that.stopBar()
          that.uploadingBar = false
          that.uploadPercentage = 0
          that.suceessmessage = true
          that.url = null
          that.choosed = true
          setTimeout(()=>{
            that.suceessmessage = false            
          },2000)

          //this.getExistingBanner()
        })
      } else {
        this.aspectRatioError = "Please upload 3:1 aspect ratio Image"
        this.choosed = true
        //this.errorMessage = null        
      }
    },
    selectNoBanner(){
      this.bannerDetail.ImageUrl =''
    },
    startBar() {
      this.interval = setInterval(() => {
        this.uploadPercentage += 10
      }, 200)
    },
    stopBar() {
      clearInterval(this.interval)
    },
    // async changeBannerHandle(e){
    //   const valid =  await this.isUrlValid(e.target.value)     
    //   if(valid){
    //     this.linkError = null
    //   }else{
    //     this.linkError = 'Banner link is not valid !'
    //   }
    // },
    isUrlValid(userInput) {
       if(userInput == '')
            return true
        var res = userInput.match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)
        if(res == null)
            return false
        else
            return true
    },
    async saveBanner(){
      console.log("this>>>>>",this.bannerDetail)
      var that = this
      const valid =  await this.isUrlValid(this.bannerDetail.Link)     
      if(valid){
        this.linkError = null
      }else{
        this.linkError = 'Banner link is not valid !'
        return
      }

      this.bannerDetail.LastModBy = this.trainer.id
      this.bannerDetail.LastModOn = new Date().toISOString()
      this.saveButton()
      if(this.type=='Edit'){
        axios.post(this.$expressApi+`editBanner?staging=`+this.$isStage,this.bannerDetail)
          .then(response =>{ 
            console.log("response---->>",response.data)
            that.resetSaveButton()
            //that.reset()
            that.$emit('saved')
            that.$refs.bannerModal.close()          
          }).catch(e => {
            that.resetSaveButton()
            console.log("Error from Api -->",e)
        })
      }else{
        this.bannerDetail.AddedBy = this.trainer.id
        this.bannerDetail.AddedOn = new Date().toISOString()
        axios.post(this.$expressApi+`addBanner?staging=`+this.$isStage,this.bannerDetail)
          .then(response =>{ 
            console.log("add response---->>",response.data)
            //that.reset()
            that.resetSaveButton()
            that.$emit('saved')
            that.$refs.bannerModal.close()          
          }).catch(e => {
            that.resetSaveButton()
            console.log("Error from Api -->",e)
        })
      }
    },
    reset(){
      this.bannerDetail={
        "ImageUrl": "",
        "Link": "",
        "Type": "REGULAR",
        "AddedBy": '',
        "LastModBy": '',
        "AddedOn": '',
        "LastModOn": ''
      }
      this.bannerDetail.Link=''
      this.bannerLink =''
      this.suceessmessage=null
      this.errorMessage= "Fill in the photo with size below 1 mb"
      this.aspectRatioError= null
      this.uploadingBar= false
      this.msg='Are you sure want to remove banner?'
      this.hasError= false
      this.choosed= true
      this.file= {}
      this.url=null
      this.uploadPercentage= 0
      this.interval= null
      this.suceessLinkMessage=false
      this.linkError=null
      document.getElementById("uploadInputFile").value = ""
    },
    saveButton() {
        const btnsave = document.querySelector('#save-banner')
        btnsave.innerHTML = 'Saving...'
        btnsave.setAttribute('disabled', true)
      },
    resetSaveButton() {
        const btnsave = document.querySelector('#save-banner')
        btnsave.innerHTML = 'Save'
        btnsave.removeAttribute('disabled', true)
    },



    
  },
  created() {
    //this.getAllTags()
    //this.$watch("show", function(val) {})
  },

  watch: {
    show(oldVal, newVal) {
      if (this.show) {
        this.openBannerModal()
      }
    }
  },
  components: {
    SweetModal,
    Selectize,
    TextField
  }
}
</script>
<style>
.bannerModal .sweet-title {
    text-align: center;
    color: #423799;
}
.bannerModal .sweet-modal {
  border-radius: 10px;
  border: 2px solid #ccc;
}

.bannerModal #preview {
  width: 50%;
}
.bannerModal .landscape {
    height: 250px;
    width: 100px;
    padding: 1rem;
}
.bannerModal .form__group{
      margin: 0 0 10px;
}
/* .addPromoCode .sweet-content-content input {
    width: 65%;
    border-radius: 15px;
    border: 1px solid #ccc;
    padding: 0px 15px;
    height: 40px;
    font-size: 17px;
    min-width: 165px;
}
.addPromoCode .form-data-outer {
    padding: 0px 20px 0 20px;
}
.addPromoCode .sweet-content-content textarea {
    width: 65%;
    border-radius: 15px;
    border: 1px solid #ccc;
    padding: 12px 15px;
    min-height:90px;
}
.addPromoCode .errorMsg {
  padding: 10px;
  color: red;
  text-align: center;
}
.addPromoCode .sweet-modal.is-alert .sweet-content{padding:0 5px;}
.addPromoCode .sweet-content-content label {     
    float: left;
    width: 30%;
    margin-top: 11px;
    font-size: 18px;
    margin-right: 10px;
    color: #3e3c3c;
}
.addPromoCode .saveBtn{
  text-align: center;
  margin-top:40px;
}
.addPromoCode .form-data {
    margin-bottom: 20px;
}
.my-tag-field .selectize-input{
  width:65%
} */
</style>



// WEBPACK FOOTER //
// AddEditBanner.vue?97533f2c